import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getIssueOrigin, presentIssueOrigin } from '../../utils/issueOrigin';

interface OperationalOriginBannerProps {
  metadata: unknown;
  source?: string | null;
  projectId?: string | null;
  organizationId?: string | null;
  targetExists?: boolean | null;
}

export const OperationalOriginBanner: React.FC<OperationalOriginBannerProps> = ({
  metadata,
  source,
  projectId,
  organizationId,
  targetExists,
}) => {
  const navigate = useNavigate();
  const origin = getIssueOrigin({
    metadata,
    source,
    projectId,
    organizationId,
    targetExists,
  });
  const quiet = origin.kind !== 'operational';

  return (
    <div className={`border-b px-3 py-1.5 ${quiet
      ? 'border-slate-200 bg-slate-50 dark:border-slate-800 dark:bg-slate-900/40'
      : 'border-sky-200 bg-sky-50 dark:border-sky-900/40 dark:bg-sky-950/30'}`}
    >
      <p className={`text-[9px] font-bold uppercase tracking-wider ${quiet
        ? 'text-slate-500 dark:text-slate-400'
        : 'text-sky-800 dark:text-sky-300'}`}
      >
        Origem
      </p>
      <p className={`mt-0.5 text-[11px] font-medium ${quiet
        ? 'text-slate-700 dark:text-slate-200'
        : 'text-sky-950 dark:text-sky-100'}`}
      >
        {presentIssueOrigin(origin)}
      </p>
      {origin.context.map((line) => (
        <p key={line.label} className="mt-0.5 text-[10px] text-slate-600 dark:text-slate-300">
          {line.label}: {line.value}
        </p>
      ))}
      {origin.navigation ? (
        <button
          type="button"
          onClick={() => navigate(origin.navigation!.href)}
          className="mt-1 text-[10px] font-semibold text-sky-700 underline-offset-2 hover:underline dark:text-sky-300"
        >
          Abrir origem
        </button>
      ) : null}
      {origin.unavailableReason ? (
        <p className="mt-0.5 text-[10px] text-slate-500 dark:text-slate-400">{origin.unavailableReason}</p>
      ) : null}
    </div>
  );
};
